module.exports = __webpack_public_path__ + "img/ch5.1833d0e3.jpeg";